//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { BillingAddressDetails } from './models/BillingAddressDetails';
import type { BillingBankDetailDetails } from './models/BillingBankDetailDetails';
import type { BillingOrderNumberDetails } from './models/BillingOrderNumberDetails';
import type { ChangeFinancialConditionDetails } from './models/ChangeFinancialConditionDetails';
import type { ChangeHeadOfficeAddressDetails } from './models/ChangeHeadOfficeAddressDetails';
import type { ContractTransferDetails } from './models/ContractTransferDetails';
import { CustomerDecision } from './models/CustomerDecision';
import type { CustomerRequestNonComplianceResponse } from './models/CustomerRequestNonComplianceResponse';
import type { DocumentAccountExtractDetails } from './models/DocumentAccountExtractDetails';
import type { DocumentContractRelatedDetails } from './models/DocumentContractRelatedDetails';
import type { DocumentCopyOfContractualElementDetails } from './models/DocumentCopyOfContractualElementDetails';
import type { DocumentEquipmentRelatedDetails } from './models/DocumentEquipmentRelatedDetails';
import type { EndOfContractDenialOfContractRenewalDetails } from './models/EndOfContractDenialOfContractRenewalDetails';
import type { EndOfContractEarlyRedemptionDetails } from './models/EndOfContractEarlyRedemptionDetails';
import type { EndOfContractExerciseOfPurchaseOptionDetails } from './models/EndOfContractExerciseOfPurchaseOptionDetails';
import type { EndOfContractReturnOfEquipmentDetails } from './models/EndOfContractReturnOfEquipmentDetails';
import type { EndOfContractTerminationOfContractDetails } from './models/EndOfContractTerminationOfContractDetails';
import type { FileParameter } from './models/FileParameter';
import { PaymentMethod } from './models/PaymentMethod';
import { UploadFileType } from './models/UploadFileType';
import { Utilities } from './Utilities';

export class CustomerRequestsDetailsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        submitCustomerRequestNonComplianceResponse: (): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/response/non-compliance';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        submitCustomerRequestBuybackResponse: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/{siren}/response/buyback';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getDocumentCopyOfContractualElementDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/document-copy-of-contractual-element/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getDocumentContractRelatedDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/document-contract-related/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getDocumentAccountExtractDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/document-account-extract/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getDocumentEquipmentRelatedDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/document-equipment-related/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getBillingBankDetailDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/billing-bank-detail/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getBillingOrderNumberDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/billing-order-number/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getBillingAddressDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/billing-address/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getChangeHeadOfficeAddressDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/change-head-office-address/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getChangeFinancialConditionDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/change-financial-condition/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getEndOfContractReturnOfEquipmentDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/end-of-contract-return-of-equipment/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getEndOfContractDenialOfContractRenewalDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/end-of-contract-denial-of-contract-renewal/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getEndOfContractEarlyRedemptionDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/end-of-contract-early-redemption/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getEndOfContractExerciseOfPurchaseOptionDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/end-of-contract-exercise-of-purchase-option/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getEndOfContractTerminationOfContractDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/end-of-contract-termination-of-contract/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getContractTransferDetails: (
			caseId: string,
        ): string => {
            let clientRequestUrl = '/api/v1/customer-requests-details/contract-transfer/{caseId}';
            if (caseId === undefined || caseId === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('caseId'));
            }
            clientRequestUrl = clientRequestUrl.replace('{caseId}', encodeURIComponent(String(caseId)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Submit response phase one
     * @param body (optional) 
     * @return OK
     */
    async submitCustomerRequestNonComplianceResponse(
        body?: CustomerRequestNonComplianceResponse,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitCustomerRequestNonComplianceResponse();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Submit response phase two
     * @param caseId (optional) 
     * @param contractId (optional) 
     * @param comment (optional) 
     * @param customerDecision (optional) 
     * @param paymentMethod (optional) 
     * @param documents (optional) 
     * @param letterFile (optional) 
     * @param creditTransferFile (optional) 
     * @return OK
     */
    async submitCustomerRequestBuybackResponse(
        siren: string,
        caseId?: string,
        contractId?: string,
        comment?: string,
        customerDecision?: CustomerDecision,
        paymentMethod?: PaymentMethod,
        documents?: UploadFileType[],
        letterFile?: FileParameter,
        creditTransferFile?: FileParameter,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.submitCustomerRequestBuybackResponse(
            siren,
        );

        const content = new FormData();
        if (caseId === null || caseId === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('caseId'));
        } else {
            content.append('caseId', caseId.toString());
        }
        if (contractId === null || contractId === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('contractId'));
        } else {
            content.append('contractId', contractId.toString());
        }
        if (comment === null || comment === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('comment'));
        } else {
            content.append('comment', comment.toString());
        }
        if (customerDecision === null || customerDecision === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('customerDecision'));
        } else {
            content.append('customerDecision', customerDecision.toString());
        }
        if (paymentMethod !== null && paymentMethod !== undefined) {
            content.append('paymentMethod', paymentMethod.toString());
        }
        if (documents === null || documents === undefined) {
            throw new Error(Utilities.parameterErrors.cannotBeNull('documents'));
        } else {
            documents.forEach((item_, index_) => {
                    content.append(`documents[${index_}]`, item_.toString());
                });
        }
        if (letterFile !== null && letterFile !== undefined) {
            content.append('letterFile', letterFile.data, letterFile.fileName ? letterFile.fileName : 'letterFile');
        }
        if (creditTransferFile !== null && creditTransferFile !== undefined) {
            content.append('creditTransferFile', creditTransferFile.data, creditTransferFile.fileName ? creditTransferFile.fileName : 'creditTransferFile');
        }

        const options = {
            body: content,
            method: 'POST',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Get Document Copy Of Contractual Element Details
     * @return OK
     */
    async getDocumentCopyOfContractualElementDetails(
        caseId: string,
    ): Promise<DocumentCopyOfContractualElementDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getDocumentCopyOfContractualElementDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<DocumentCopyOfContractualElementDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get Document Contract Related Details
     * @return OK
     */
    async getDocumentContractRelatedDetails(
        caseId: string,
    ): Promise<DocumentContractRelatedDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getDocumentContractRelatedDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<DocumentContractRelatedDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get Document Account Extract Details
     * @return OK
     */
    async getDocumentAccountExtractDetails(
        caseId: string,
    ): Promise<DocumentAccountExtractDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getDocumentAccountExtractDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<DocumentAccountExtractDetails>(_response, false, ['start', 'end', 'statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get Document Equipment Related Details
     * @return OK
     */
    async getDocumentEquipmentRelatedDetails(
        caseId: string,
    ): Promise<DocumentEquipmentRelatedDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getDocumentEquipmentRelatedDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<DocumentEquipmentRelatedDetails>(_response, false, ['start', 'end', 'statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get Billing Bank Detail Details
     * @return OK
     */
    async getBillingBankDetailDetails(
        caseId: string,
    ): Promise<BillingBankDetailDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getBillingBankDetailDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<BillingBankDetailDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get Billing Order Number Details
     * @return OK
     */
    async getBillingOrderNumberDetails(
        caseId: string,
    ): Promise<BillingOrderNumberDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getBillingOrderNumberDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<BillingOrderNumberDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get Billing Address Details
     * @return OK
     */
    async getBillingAddressDetails(
        caseId: string,
    ): Promise<BillingAddressDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getBillingAddressDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<BillingAddressDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get head office address Details
     * @return OK
     */
    async getChangeHeadOfficeAddressDetails(
        caseId: string,
    ): Promise<ChangeHeadOfficeAddressDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getChangeHeadOfficeAddressDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ChangeHeadOfficeAddressDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get head office address Details
     * @return OK
     */
    async getChangeFinancialConditionDetails(
        caseId: string,
    ): Promise<ChangeFinancialConditionDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getChangeFinancialConditionDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ChangeFinancialConditionDetails>(_response, false, ['effectiveDate', 'statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get End Of Contract Return Of Equipment Details
     * @return OK
     */
    async getEndOfContractReturnOfEquipmentDetails(
        caseId: string,
    ): Promise<EndOfContractReturnOfEquipmentDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getEndOfContractReturnOfEquipmentDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<EndOfContractReturnOfEquipmentDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get End Of Contract Denial Of Contract Renewal Details
     * @return OK
     */
    async getEndOfContractDenialOfContractRenewalDetails(
        caseId: string,
    ): Promise<EndOfContractDenialOfContractRenewalDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getEndOfContractDenialOfContractRenewalDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<EndOfContractDenialOfContractRenewalDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get End Of Contract Early Redemption Details
     * @return OK
     */
    async getEndOfContractEarlyRedemptionDetails(
        caseId: string,
    ): Promise<EndOfContractEarlyRedemptionDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getEndOfContractEarlyRedemptionDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<EndOfContractEarlyRedemptionDetails>(_response, false, ['effectiveDate', 'statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get End Of Contract Return Of Equipment Details
     * @return OK
     */
    async getEndOfContractExerciseOfPurchaseOptionDetails(
        caseId: string,
    ): Promise<EndOfContractExerciseOfPurchaseOptionDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getEndOfContractExerciseOfPurchaseOptionDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<EndOfContractExerciseOfPurchaseOptionDetails>(_response, false, ['statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'effectiveDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get End Of Contract Termination Of Contract Details
     * @return OK
     */
    async getEndOfContractTerminationOfContractDetails(
        caseId: string,
    ): Promise<EndOfContractTerminationOfContractDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getEndOfContractTerminationOfContractDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<EndOfContractTerminationOfContractDetails>(_response, false, ['effectiveDate', 'statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }

    /**
     * Get Contract Transfer Details
     * @return OK
     */
    async getContractTransferDetails(
        caseId: string,
    ): Promise<ContractTransferDetails> {
        const clientRequestUrl = this.baseUrl + this.routes.getContractTransferDetails(
            caseId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ContractTransferDetails>(_response, false, ['effectiveDate', 'statusTimeStamp', 'lastUnreadDocReceptionDate', 'dateOfReception', 'creationDate', 'lastNonComplainDate', 'startDate', 'endDate', 'birthDate', 'scliFeedbackDate', 'instructionDate', 'lastNonComplainFdDate', 'nonConformDate', 'lastReminderDate']);
    }
}
